import styled from 'styled-components'

import { LegendItem } from './../barChartCard.styles'

export const GroupLegendItemWrapper = styled(LegendItem)`
    gap: 8px;
`

export { LegendItemLabel } from './../barChartCard.styles'
